import React from 'react'
import { Link, Typography, Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles'
import { useTranslation } from '../../hooks/helper/useTranslation'

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.common.white,
  },
}))

export const About: React.FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Stack gap={2}>
      <Link
        className={classes.link}
        component={RouterLink}
        to="/about"
        underline="hover"
      >
        <Typography variant="h6">{t('footer:about.title')}</Typography>
      </Link>

      <Typography variant="body2">{t('footer:about.team')}</Typography>
      <Typography variant="body2">{t('footer:about.betmen')}</Typography>
      <Typography variant="body2">{t('footer:about.development')}</Typography>
    </Stack>
  )
}
